module.exports = __webpack_public_path__ + "static/media/fullpage-image.d212b132.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Layout/images/fullpage-image.jpeg
// module id = 123
// module chunks = 0